export default "/images/3741ee5c5d6529e653cd9ae3c4a798b2.avif";